import React, {useState, useContext} from 'react';
import { CircularProgress, Avatar, Button, CssBaseline, TextField, Link, Box, Typography, Container, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import bg_image from '../asset/pictures/adventist-symbol-tm--white.png';
import { API } from '../conf';
import { Context } from '../App';
import { Buffer } from 'buffer';
import { useNavigate } from 'react-router-dom';
import logo from '../asset/pictures/logo_thyba.png';
import { Visibility, VisibilityOff } from '@mui/icons-material';

function Copyright(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}Thyba{` ${new Date().getFullYear()}.`}
        </Typography>
    );
}


export default function SignIn() {
  const [loading, setLoad] = useState(false)
  const [showPwd, setShowPwd] = useState(false)
  const [msg, setMsg] = useState()
  const { updateConnect, setEglise } = useContext(Context)
  const navigate = useNavigate()

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const identifiant = data.get('identifiant');
        const mdp = data.get('password')

        if (identifiant.length > 0 && mdp.length > 0) {
            setLoad(true)
            fetch(API.concat('/login'), {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic '+Buffer.from(identifiant+':'+mdp,'utf-8').toString('base64'),
                },
            })
            .then(async(response)=> {
                if(response.status === 200)  {
                    const user = await response.json()
                    sessionStorage.setItem('user', JSON.stringify(user))
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    fetch(API.concat(`/eglises/by/${JSON.stringify({number: {$in: user.eglises.length===1&&user.level<=2?user.eglises:[user.organisation]}})}`), {
                        method:'GET',
                        headers:{
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + response.headers.get('x-auth-token')
                        }
                    }).then(async(response) => {
                        if(response.status === 401) {
                            sessionStorage.clear()
                            updateConnect(false)
                        }else if (response.status === 200) {
                            const json = await response.json(); 
                            if(json.length === 1){
                                sessionStorage.setItem('original_eglise', JSON.stringify(json[0]))
                                setEglise(json[0]) 
                            }
                        }
                        updateConnect(response.headers.get('x-auth-token') ? true : false);
                        navigate('/')
                    })
                    
                }else{
                    const text = await response.json()
                    setMsg(text.error)
                    setLoad(false)
                }
            })
        }
    };

  return (
    <div style={{display:'flex', flex:1}}>
        <div style={{width:'40%', height:"100vh", backgroundColor:'#255760', backgroundImage:`url(${bg_image})`, backgroundRepeat:"no-repeat", backgroundPosition:"center", backgroundSize:"contain"}}>
        </div>
        <div style={{display:'flex', width:"60%", flex:1, justifyContent:"center", alignItems:"center", flexDirection:'column'}}>
            <img src={logo} alt='logo' style={{width:'360px', height:'200px', marginTop:-10}} />
            <Typography fontSize={16} color='primary' marginTop={-7} marginBottom={5} align='center'>Application de Trésorerie de l'Église Adventiste</Typography>
        
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
                >
                <Avatar sx={{ m: 1, bgcolor: '#255760' }}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Connexion
                </Typography>
                <Typography color={'carmine.main'}>{msg}</Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <TextField color='primary' required autoFocus fullWidth label="Identifiant" name="identifiant" autoComplete="username" sx={{marginBottom:3}}/>
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="outlined-adornment-password">Mot de passe</InputLabel>
                        <OutlinedInput
                            name='password'
                            type={showPwd ? 'text' : 'password'}
                            autoComplete='current-password'
                            endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                aria-label={showPwd ? 'masquer le mot de passe' : 'afficher le mot de passe'}
                                onClick={() => setShowPwd(!showPwd)}
                                onMouseDown={(event) => event.preventDefault()}
                                edge="end"
                                >
                                    {showPwd ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                            }
                            label="Mot de passe"
                        />
                    </FormControl>
                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={loading} >
                        {loading&&<CircularProgress size={18} color='primary' style={{marginRight:7}}/>} Connexion
                    </Button>
                </Box>
                </Box>
            </Container>
            <div style={{position:'absolute', bottom:0, display:'flex', justifyContent:'center'}}><Copyright sx={{ mt: 8, mb: 4 }} style={{bottom:0}} /></div>
        </div>
    </div>
  );
}